import { Table } from "antd";
import { Tooltip } from "antd";
import { useHistory } from "react-router-dom";

import { EyeOutlined } from "@ant-design/icons";
import { useMemo } from "react";

export function TableValidacao({ data, onChangePage, page, size, totalElements, module, loading, onChangeSize }) {
  const history = useHistory();

  const dataSource = useMemo(() => data.map( value => ({ ...value, key: value.id, aplicacao: value.aplicacao.replace("_", " ")  })), [data]);

  const columns = [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "name",
      align: "center",
    },
    {
      title: "Órgão",
      dataIndex: "orgao",
      key: "orgao",
      align: "center",
    },
    {
      title: "Aplicação",
      dataIndex: "aplicacao",
      key: "aplicacao",
      align: "center",
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      key: "cpf",
      align: "center",
    },
    {
      title: "Nivel",
      dataIndex: "nivel",
      key: "nivel",
      align: "center",
    },
    {
      title: "Ações",
      key: "action",
      align: "center",
      render: (text, record) => (
        <>
          <div onClick={() => history.push(`/${module}/${record.key}`)}>
            <Tooltip title="Visualizar ficha">
              <EyeOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  function onShowSizeChange(current, pageSize) {
    onChangeSize(pageSize);
  }


  return (
    <Table
      loading={loading}
      tableLayout="fixed"
      dataSource={dataSource}
      columns={columns}
      pagination={{
        onChange: pageChange => {
          onChangePage(pageChange);
        },
        onShowSizeChange: onShowSizeChange,
        pageSize: size,
        current: page,
        defaultCurrent: page,
        total: totalElements,
      }}
    />
  );
}
